import Paginate from 'vuejs-paginate'
export default {
  name: 'list',
  components: {Paginate},
  props: [],
  data () {
    return {
      per_page: 20,
      loading: false,
      group_faq_id: '',
      search: ''
    }
  },
  computed: {
    faqs () {
      return this.$store.getters['FAQ/getListFAQ']
    },
    last_page () {
      return this.$store.getters['FAQ/getLastpage']
    },
    total () {
      return this.$store.getters['FAQ/getTotal']
    },
    group_faq () {
      return this.$store.getters['GroupFAQ/getListGroupFAQ']
    }
    // fields () {
    //   return this.$store.getters['FAQ/getField']
    // }
  },
  mounted () {
    if (this.$route.query.group_faq) {
      this.group_faq_id = this.$route.query.group_faq
    }
    this.$loading.start()
    this.loading = true
    Promise.all([
      this.$store.dispatch('FAQ/getListFAQ', {page: 1, per_page: this.per_page, search: this.search, group_faq_id: this.group_faq_id}),
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: 1, per_page: 'all'})
    ]).then(res => {
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    create () {
      this.$router.push('create')
    },
    detail (faq) {
      this.$router.push(faq.id + '/detail')
    },
    changeTotal () {
      this.$loading.start()
      this.loading = true
      Promise.all([
        this.$store.dispatch('FAQ/getListFAQ', {page: 1, per_page: this.per_page, search: this.search, group_faq_id: this.group_faq_id})
      ]).then(res => {
        this.$loading.complete()
        this.loading = false
      }).catch(errors => {
        this.$loading.fail()
        this.loading = false
      })
    },
    changePage (page) {
      this.$loading.start()
      this.loading = true
      Promise.all([
        this.$store.dispatch('FAQ/getListFAQ', {page: page, per_page: this.per_page, search: this.search, group_faq_id: this.group_faq_id})
      ]).then(res => {
        this.$loading.complete()
        this.loading = false
      }).catch(errors => {
        this.$loading.fail()
        this.loading = false
      })
    },
    filter () {
      this.$loading.start()
      this.loading = true
      Promise.all([
        this.$store.dispatch('FAQ/getListFAQ', {page: 1, per_page: this.per_page, search: this.search, group_faq_id: this.group_faq_id})
      ]).then(res => {
        this.$loading.complete()
        this.loading = false
      }).catch(errors => {
        this.$loading.fail()
        this.loading = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/faq/list/list.js